<template>
<div class="chapter">
<div class="inner_page">
<p class="fmm">This one’s for Lydia “Ford” Kawka, wherever she’s gone.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?3022b452